
import isInViewport from "./isInViewport";
// import Plyr from "plyr";

//============================================================
// Btn Delete
//============================================================

var sectionDelete = $("[data-delete]");
sectionDelete.length &&
  sectionDelete.map((idx, el) => {
    $(document).on("click", ".btn-delete", el, () => {
      $(el).remove();
    });
  });

//============================================================
// Detect Mac
//============================================================
if(navigator.userAgent.indexOf('Mac') > 0)
  $('body').addClass('mac-os');

//============================================================
// Detect iOS
//============================================================
function iOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

if(iOS())
  $('body').addClass('ios');

//============================================================
// Question toggle mobie
//============================================================
$(document).on('click', '.s-questions .box-item .title', function(e) {
  e.preventDefault();
  $(this).toggleClass('is-active');
  $(this).siblings('.content').stop().slideToggle();
});

//============================================================
// Page loading || Scroll loading
//============================================================
let itemsAnim = document.querySelectorAll(`[data-scroll]`);

$(window).on('load', function() {
  setTimeout(function() {
    $('#page-loading').addClass('loaded');

    setTimeout(function () {
      document.documentElement.classList.add("loaded")

      if ($('.hero-video').length) {
        $('.hero-video').append('<video id="hero-video" loop playsinline muted autoplay><source src="'+ $('.hero-video').attr('data-source') +'" type="video/mp4" /></video>');
        // new Plyr(document.getElementById('hero-video'));
      }
    }, 600);
  }, 300);

  setTimeout(function() {
    $('#page-loading').remove();
  }, 3000);

  setTimeout(function () {
      document.documentElement.classList.add('is-ready');
  }, 300);

  itemsAnim.forEach((el, idx) => {
      if (isInViewport(el)) {
          setTimeout(function () {
              el.classList.add('is-inview');
          }, 80 * (idx + 1));
      }
  })
});

$(window).on('scroll', function() {
  itemsAnim.forEach((el, idx) => {
      if (isInViewport(el)) {
          setTimeout(function () {
              el.classList.add('is-inview');
          }, 20 * (idx + 1));
      }
  })
});

//============================================================
// Hover video
//============================================================
// $('.js-hover-video').hover(
//   function() {
//     $(this).find('video').get(0).play();
//   }, function() {
//     $(this).find('video').get(0).pause();
//   }
// );
$("body").on('mouseenter', '.js-hover-video', function( event ) {
  let video = $(this).find('video');
  if (video.length) {
    video.get(0).play();
  } else {
    let hoverVideo = $(this).find('.hover-video');
    hoverVideo.append('<video loop playsinline muted autoplay><source src="'+ hoverVideo.attr('data-video') +'" type="video/mp4" /></video>');
  }
}).on('mouseleave', '.nachricht', function( event ) {
  let video = $(this).find('video');
  if (video.length) video.get(0).pause();
});

//============================================================
// Play video inside
//============================================================
$(document).on('click', '.video-inside-btn', function(e) {
  e.preventDefault();
  $(this).parent().parent().addClass('play-video-inside').find('.plyr__control--overlaid').trigger('click');
});

//============================================================
// one-click
//============================================================
$('.one-click').one('click', function(e) {
  e.preventDefault();
  var $content = $(this).find('[data-content]');
  $content.text($content.attr('data-content'));
});